{
  "partnerPortal": {
    "addDevice": {
      "onp": {
        "no": "No",
        "yes": "Yes",
        "yesHint": "The customer can enter their number porting details later when activating the plan."
      },
      "quantity": {
        "decrement": "Decrease quantity",
        "increment": "Increase quantity"
      },
      "rateSelection": {
        "dataTariffs": "Data plans",
        "flatHome": "Flat Home",
        "flatMobile": "Flat Mobile",
        "label": "Rate",
        "required": "Please select a plan to continue."
      },
      "step1": {
        "esim": {
          "description": "Digital SIM — no SIM card required."
        },
        "required": "Please select a SIM type to continue.",
        "simCard": {
          "description": "For devices with a SIM card slot."
        },
        "step": "Step 1"
      },
      "step4": {
        "checkingCustomer": "Checking customer account...",
        "existingCustomer": "This customer is already registered with Digital Republic. Personal details do not need to be entered again.",
        "hint": "Ask the customer for their ID to avoid errors.",
        "hintTitle": "Tip!"
      },
      "stepMenuLabel": "Jump to another step",
      "steps": {
        "personal-details": {
          "description": "Enter the customer’s information or help with ID verification.",
          "label": "Customer Data"
        },
        "quantity": {
          "description": "How many plans with the same configuration should be ordered?",
          "label": "Number of plans"
        },
        "sim-type": {
          "description": "Choose whether the customer will receive a SIM card or an eSIM.",
          "label": "Choose SIM Type"
        }
      },
      "submit": "Submit order",
      "submitting": "Submitting…",
      "subtitle": "Add a plan for a customer."
    },
    "cockpit": {
      "callToAction": "View plans",
      "description": "Discover our current plans and partner conditions.",
      "heading": {
        "description1": "Welcome to the sales partner portal!",
        "description2": "Register and assign a SIM card to Digital Republic customers or new customers.",
        "greeting": "Hello Partner"
      },
      "mobileInternet": "Mobile internet for everything and everyone"
    },
    "success": {
      "addMorePlans": "Add more plans",
      "back": "To cockpit",
      "existingCustomer": {
        "partnerSupport": {
          "hint": "If identity verification is not yet complete, the customer will be guided through the ID check during activation.",
          "list": {
            "1": "Log in to the customer portal with their existing credentials",
            "2": "Open \"To activate\" in the cockpit and select the new plan",
            "3": "Complete the activation flow"
          }
        },
        "whatHappensNext": {
          "list": {
            "1": "The customer may receive a confirmation email",
            "2": "The plan appears under \"To activate\" in the cockpit",
            "3": "The customer can log in with their existing credentials — no new account setup needed"
          },
          "subtitle": "The plan has been added to the customer's account and is waiting in the customer portal.",
          "title": "The plan is ready to activate"
        }
      },
      "newCustomer": {
        "partnerSupport": {
          "hint": "The customer can also complete these steps later on their own.",
          "list": {
            "1": "Open the welcome email and set a password",
            "2": "Log in to the customer portal",
            "3": "Complete identity verification (ID check) on their smartphone",
            "4": "Activate the plan under \"To activate\" in the cockpit"
          }
        },
        "whatHappensNext": {
          "list": {
            "1": "A link to set their password",
            "2": "Access to the customer portal",
            "3": "Their new plan, ready to activate"
          },
          "subtitle": "Shortly, the customer will receive a welcome email with everything they need to get started.",
          "title": "The customer will receive an email"
        }
      },
      "partnerSupport": {
        "subtitle": "Please support the customer with the following steps in the customer portal:",
        "title": "Help the customer activate their plan"
      },
      "successMessage": "Order submitted successfully!"
    },
    "welcomeScreen": {
      "animationText": "Let’s get started, welcome!",
      "descriptionText": "Activate eSIMs & SIM cards for your clients. Check out \n<0>our plans here</0>. Digital Republic activates eSIMs in minutes, with no waiting time.",
      "title": "Log In"
    }
  },
  "portal": {
    "Error": {
      "eSimError": "eSIM data could not be loaded. Please try again later."
    },
    "add-device": {
      "blockedModal": {
        "viewBills": "Go to bills"
      },
      "deleteBasket": {
        "title": "Your selection will be completely deleted"
      },
      "esimInfoModal": {
        "benefits": {
          "instant": "Instant activation without waiting for a SIM card",
          "multiTariff": "Multiple plans on one device possible",
          "noSwap": "No SIM card swap needed"
        },
        "confirm": "Generate eSIM",
        "description": "An eSIM (embedded SIM) is a digital SIM card built into your device. You no longer need a SIM card.",
        "requirementText": "Your device must be eSIM-capable (e.g. iPhone XS or newer, Samsung Galaxy S20 or newer).",
        "requirementTitle": "Requirement",
        "title": "What is an eSIM?"
      },
      "heading": "Add plan",
      "invalidBasket": {
        "confirm": "Start again",
        "description": "Your current basket is no longer valid. We'll delete it and start the process again.",
        "title": "Basket no longer valid"
      },
      "overflowMenuLabel": "More actions",
      "simSelection": {
        "generateEsimLink": "No SIM card? Generate eSIM directly",
        "reasons": {
          "IDCheckOpen": "Your ID check has not been completed yet.",
          "TooManySIMs": "You have reached the maximum number of active SIM cards."
        }
      },
      "steps": {
        "checkout": {
          "description": "Review your details before completing onboarding.",
          "label": "Summary"
        },
        "number-porting": {
          "description": "Porting your Swiss number from your previous provider is free and only possible with one of our Flat Mobile subscriptions.",
          "label": "Keep your number"
        },
        "rate-selection": {
          "label": "Subscription"
        },
        "sim-selection": {
          "label": "SIM type"
        }
      },
      "subheading": "Add another plan to your cockpit by activating a SIM card or an eSIM.",
      "success": {
        "fraudCheckInfo": "We are checking your details. This should take a few minutes. You will need to perform the ID Check afterwards.",
        "info": "We are preparing the next step for your new SIM.",
        "title": "Thank you for your order!"
      }
    },
    "authenticator": {
      "app": {
        "setup": {
          "step1": {
            "copied": "Copied your qr code.",
            "copy-error": "Error while copying your QR code.",
            "description": "If you haven't already done so, download an authenticator app. For a list of supported apps and detailed setup instructions, please visit our <FAQ />. Once you have installed the app, open it and use the app to scan the QR code displayed.",
            "enter-key-manually": "Enter key manually",
            "faqOn2faApps": "FAQ on 2FA Apps",
            "faqUrl": "https://support.digitalrepublic.ch/en/support/solutions/articles/33000290333",
            "show-qr-code": "Show QR code",
            "title": "1. Scan QR Code",
            "your-manual-key": "Your manual key:"
          },
          "step2": {
            "description": "After you have scanned the QR code or entered the key manually, your app will generate a 6-digit confirmation code. Enter this code below to complete the setup.",
            "invalidCode": "Invalid code",
            "title": "2. Enter the Confirmation Code"
          }
        }
      },
      "backupCodes": {
        "copy": "Copy codes",
        "copyError": "Failed to copy codes.",
        "copySuccess": "Codes copied successfully!",
        "description": "You will find your personal recovery codes in the box below. You will need these codes if you lose your device with the Authenticator app or no longer have access to it. Please make a note of these codes or download them and keep them in a safe place.   \n \nThe codes allow you to restore your account or set up an Authenticator app on your new device. Each code can only be used once.",
        "download": "Download codes",
        "downloadSuccess": "Downloaded codes successfully!",
        "error": "Error while confirming your 2FA. Try again.",
        "nameRequired": "Please enter your name.",
        "nameWrong": "Please sign with your registered name.",
        "proceedWithSteps": "Proceed with the following steps",
        "steps": {
          "1": {
            "description": "Make sure that you have written down your recovery codes or saved them in a safe place. Only you should be able to access these codes.",
            "title": "1. Copy and save your codes securely"
          },
          "2": {
            "placeholder": "Type \"{{name}}\" to confirm.",
            "title": "2. Confirm with your name that you have saved your recovery codes."
          }
        },
        "success": "Succesfully set up two factor authentication.",
        "title": "Almost there!",
        "uniqueRecoveryCodes": "Personal recovery codes"
      },
      "sms": {
        "enterNumber": {
          "description": "Please enter the cell phone number you would like to use to receive the SMS with your confirmation codes.",
          "label": "Phone number",
          "sendCode": "send code",
          "title": "Enter Your Cell Phone Number"
        },
        "verification": {
          "description": "A code has been sent to {{number}}. Enter the code below to confirm your mobile number and complete the setup.",
          "digit": "Digit {{index}} of {{count}}",
          "label": "Verification code",
          "resend": "Send code again",
          "resendToast": {
            "error": "Error while sending the code. Try again.",
            "success": "Code sent successfully."
          },
          "secondsLeft": "in {{count}} seconds",
          "title": "Enter the verification code"
        }
      },
      "verifyEmail": {
        "confirmCode": "Confirm code",
        "confirmEmailAddress": "Verify your email address",
        "description": "To complete your registration, we need to verify your email address. Please enter the code we sent to {{email}}.",
        "enterEmailAgain": "Re-enter email address",
        "error": {
          "invalidCode": "Invalid Code",
          "maxCodes": "Max amount of active codes reached",
          "maxRetry": "Maximum number of verification attempts reached"
        },
        "success": "Email address successfully verified",
        "successResend": "Code sent",
        "wrongMailAddress": "Is the email address incorrect?"
      }
    },
    "bills": {
      "downloadMultiple": "Download multiple",
      "download_one": "download {{count}}",
      "download_other": "download {{count}}",
      "list": {
        "downloadBill": "Download bill",
        "empty": "There are no bills yet.",
        "headline": "Your bills",
        "status": {
          "canceled": "Canceled",
          "due": "Due",
          "paid": "Paid",
          "reminder": "Reminder"
        },
        "tableHeaders": {
          "amount": "Amount",
          "date": "Date",
          "deselectAllBills": "Deselect all invoices on this page.",
          "invoiceFor": "Bill",
          "number": "Invoice number",
          "open": "Open",
          "selectAllBills": "Select all invoices on this page."
        }
      },
      "zipName": "{{count}} bills from Digital Republic"
    },
    "bulk-sim-activation": {
      "activationFailed": "Activation failed",
      "csvError": "CSV must include ICCID, PUK, and Alias columns (e.g. Inv | ICCID, PUK 1, Alias).",
      "csvFile": "CSV file",
      "customer": {
        "email": "Email",
        "heading": "Logged-in user",
        "id": "Customer ID",
        "loading": "Loading customer...",
        "notAvailable": "n/a",
        "paymentMode": "Payment mode",
        "unknown": "Unknown customer"
      },
      "description": "Upload a CSV and run SIM activation sequentially with onboarding endpoints.",
      "heading": "Bulk SIM activation",
      "manualPaymentRequired": {
        "description": "Activation is restricted to customers with payment mode Manual.",
        "title": "Manual payment required"
      },
      "startActivation": "Start activation ({{count}} pending)",
      "status": {
        "failed": "Failed",
        "pending": "Pending",
        "running": "Running",
        "success": "Success"
      },
      "steps": {
        "addBasketEntry": "adding basket entry",
        "addOption": "adding option",
        "checkSim": "checking SIM",
        "checkout": "checkout",
        "idle": "queued",
        "saveBasket": "getting basket",
        "setAlias": "setting alias",
        "setDevice": "setting device",
        "setICCID": "setting ICCID/PUK"
      },
      "stopAfterCurrent": "Stop after current row",
      "table": {
        "alias": "Alias",
        "empty": "No CSV data loaded."
      }
    },
    "cockpit": {
      "dashboard": {
        "quickLinks": {
          "showAll": "Show all",
          "showMoreAbos_one": "+{{count}} more plan",
          "showMoreAbos_other": "+{{count}} more subscriptions",
          "title": "Your subscriptions"
        },
        "resources": {
          "fwb": {
            "button": "Invite friends now",
            "text": "Invite friends and save up to 30% on your subscriptions."
          }
        },
        "todos": {
          "addPaymentMethod": "Add a payment method",
          "fwbMobileAbo": "Book a Mobile Abo to stay in your friends group",
          "kyc": {
            "dataMismatch": "Correct your data as per your ID",
            "errorProcessingDocs": "Re-upload your ID",
            "errorProcessingSelfie": "Retry your selfie video",
            "fraudCheckPending": "Your order is being verified",
            "idUncomparable": "Retry your ID check",
            "invalidDocument": "Upload a valid ID",
            "maxAttempts": "Contact support",
            "open": "Verify your ID",
            "pending": "Your ID is being reviewed",
            "underaged": "Check age requirements"
          },
          "payOpenBills": "Pay your open bills",
          "title": "To-dos"
        }
      },
      "deviceList": {
        "noSearchResults": "Your search did not return any results.",
        "row": {
          "green": "This subscription is active.",
          "grey": "This subscription is inactive.",
          "openDevice": "Open {{alias}}",
          "red": "This subscription has been suspended.",
          "yellow": "This subscription is active and is being paused."
        }
      },
      "filter": {
        "activity": "Settings",
        "activity-labels": {
          "all": "All",
          "mobileAbo": "Mobile plan"
        },
        "additionalColumns": "Additional columns",
        "application": "SIM Type",
        "apply": "apply filters",
        "dropdowns": {
          "chooseColumns": "Choose columns",
          "column": "Column",
          "simType": {
            "placeholder": "SIM type"
          }
        },
        "openFilters": "Open filters",
        "resetFilters": "Reset filters",
        "searchBar": {
          "placeholder": "Search term",
          "toggle": "Open search"
        },
        "status-labels": {
          "activeLimited": "Being paused",
          "onpPending": "Number porting pending"
        },
        "title": "Filter"
      },
      "heading": {
        "greeting": "Hi {{name}}!"
      },
      "id-banner": {
        "open": {
          "button": "To ID Check"
        }
      },
      "idCheck": {
        "button": "To ID Check",
        "info": "Swiss law requires us to verify your identity before we can activate your SIM. Please check the requirements and information below before you start the ID check.",
        "infoFromOrder": "Swiss law requires us to verify your identity before we can activate your new SIM. Please check the requirements and information below before you start the ID check.",
        "internationalCallsWarning": "Calls within and to foreign countries are only available with a Swiss-issued document (passport, ID or permit except for N) and a registered Swiss address.",
        "prep": {
          "noTablets": "Tablets are not supported",
          "privacy": "We handle your data with care and in accordance with Swiss law",
          "recommendedBrowsers": "Up-to-date operating system (Safari or Chrome)",
          "validIdDocument": "Valid ID document"
        },
        "title": "ID Check",
        "titleFromOrder": "Last step for your new SIM"
      },
      "kycSection": {
        "idCheckFailed": {
          "text": "Your data could not be verified. Please upload your ID again.",
          "title": "Failed ID Check"
        },
        "links": {
          "maxAttempts": "https://support.digitalrepublic.ch/en/support/tickets/new",
          "underaged": "https://support.digitalrepublic.ch/en/support/solutions/articles/33000269430-can-i-also-order-a-subscription-for-my-minor-child-"
        }
      },
      "managementTile": {
        "details": {
          "sections": {
            "autoRenewal": {
              "buttons": {
                "confirm": "Confirm"
              },
              "disable": {
                "description_one": "After the <strong>remaining time of one day</strong> has passed, this plan will be paused: ",
                "description_other": "After the <strong>remaining time of {{count}} days</strong>, this subscription will no longer be renewed automatically: ",
                "goodToKnow": "You can reactivate it at any time.",
                "successMessage": "Your plan will be paused.",
                "successorWarning": "Your previously selected follow-up package <strong>{{ flatName }}</strong> will not be activated.",
                "title": "Pause subscription"
              },
              "enable": {
                "description": "The following plan continues <strong>every {{days}} days</strong>: ",
                "nextBillDescription": "Your subscription will be billed from next month. You pay nothing today.",
                "title": "Reactivate subscription"
              }
            },
            "details": {
              "changeEsim": {
                "qrCodeDone": "Your eSIM profile has been created. In 5 to 10 minutes you will receive an email with the associated QR code. Note that the QR code must be activated on your device within 24 hours.",
                "qrCodeTitle": "Scan QR Code",
                "waitingText": "Your eSIM will be generated, this will take a few minutes. The QR code will show up here, once it's ready."
              },
              "deviceDetails": "Subscription details",
              "esimHint": "Activate this SIM card as an eSIM",
              "installOnThisDevice": {
                "title": "Install eSIM on this device"
              },
              "instructionsLinkText": "View instructions",
              "networkReset": {
                "confirmationText": "If you have network problems with your SIM it can help to reset and reboot it.<0>After confirming the action, we recommend:</0>",
                "error": "Reset was not started successfully.",
                "label": "Network reset",
                "link": "Reset",
                "reasons": {
                  "openEsimChange": "Your eSIM profile is currently transferring, please wait.",
                  "openEsimReset": "Your eSIM profile is currently reloading, please wait.",
                  "openNetworkReset": "A network reset is already in progress, please wait.",
                  "openONP": "Your Number is being ported.",
                  "openOrder": "Another process is happening, please wait.",
                  "openSpeedAndLock": "Currently not possible, please wait.",
                  "simCancelled": "Your rate has been cancelled.",
                  "simInactive": "Your SIM card is inactive.",
                  "simLocked": "Your SIM card is locked.",
                  "simTerminated": "Your SIM card will be terminated."
                },
                "recommendations": {
                  "reboot": "restart your device",
                  "rebootWatchSim": "if you have a WatchSIM booked, reboot that device too",
                  "remove": "in case of a physical SIM card, remove it from the device and reinsert it",
                  "wait": "15 minutes waiting before the improvements take effect"
                },
                "success": "Reset was started successfully.",
                "text": "If you have network problems with your SIM, it may help to reset and reboot it.",
                "title": "Troubleshooting"
              },
              "reasons": {
                "StatusNotAllowed": "You need to delete your eSIM from your device before doing this action.",
                "noAutoRenew": "The plan is paused.",
                "noMoreActions": "Maximum number of eSIM (eSIM conversion).",
                "packageOrderInProgress": "A package order is already in progress.",
                "simFixedService": "SIM has a fixed service type.",
                "simInactive": "SIM is inactive.",
                "simNoActivePackage": "No active rate booked.",
                "simSuspended": "SIM is temporarily blocked.",
                "simTerminated": "Contract has been terminated.",
                "wrongSimType": "Wrong SIM type."
              },
              "registrationDetails": {
                "activationCode": "Activation code",
                "addressCopied": "SM-DP+ Address copied!",
                "addressCopyError": "The SM-DP+ Address could not be copied.",
                "codeCopied": "Activation code copied!",
                "codeCopyError": "The activation code could not be copied.",
                "completeActivationCode": "Complete activation code",
                "completeCodeCopied": "Complete activation code copied!",
                "completeCodeCopyError": "The complete activation code could not be copied.",
                "hideCode": "Hide code",
                "infoText": "Copy the code and enter it manually in your device to activate your eSIM.",
                "invalidCode": "The activation code for this eSIM is invalid.",
                "missingMatchingId": "There is currently no activation code available for this eSIM.",
                "showCode": "Enter code manually",
                "smdpPlusAdress": "SM-DP+ Address"
              },
              "reloadEsim": {
                "button": "Reload",
                "screens": {
                  "confirm": {
                    "text": "Are you sure you want to reactivate your eSIM? <br><br>You can then reconnect your eSIM in your device's network settings. <br><br>You can find more information about activating an eSIM on our support portal.",
                    "title": "Reload eSIM"
                  }
                },
                "text": "If you have deleted your eSIM profile on your device, you can load a new one here.",
                "title": "Reload eSIM profile"
              },
              "scanQRCode": "Scan QR code",
              "scanQRCodeText": "Scan your QR code to finally activate this device and enjoy all the benefits.",
              "simDetails": "SIM details",
              "switchFromPhysicalToEsim": {
                "screens": {
                  "confirm": {
                    "text": "You have a SIM card in your device and want to switch to eSIM?<br><br>Make sure your device is <0>eSIM-enabled</0> and then switch to an eSIM with one click.",
                    "title": "Switch to eSIM"
                  }
                }
              },
              "transferEsim": {
                "button": "Transfer",
                "screens": {
                  "confirm": {
                    "text": "Are you sure you want to activate your eSIM on a new device? <br><br>Note that the eSIM on the current device will be deactivated immediately. You can then reload your existing eSIM profile on the new device. <br><br>You can find more information about activating an eSIM on our support portal.",
                    "title": "Transfer eSIM"
                  }
                },
                "text": "Here you can transfer your eSIM profile to a new device.",
                "title": "Transfer eSIM profile"
              }
            }
          }
        },
        "roaming": {
          "addOption": {
            "countryDropdownLabel": "Destination",
            "countryList": "All packages are valid for 365 days. Check out the <0/> here.",
            "errorWait": "Booking is not possible at the moment. Please wait a few minutes and try again.",
            "noPackagesForDestination": "No roaming package is available for this destination.",
            "packagesTitle": "Roaming packages",
            "selectCountryHint": "Select your destination country to filter out the appropriate roaming packages",
            "selectPackageHint": "Select your desired roaming package directly.",
            "stepLabel": "Package selection",
            "title": "Add roaming",
            "volume": "Data volume"
          },
          "card": {
            "bookedPackagesTitle": "Booked packages",
            "dataUsageGeneric": "Data usage",
            "mobileAboTitle": "Included in your subscription",
            "noActivePackage": "No active roaming packages",
            "selectPackage": "Choose a package"
          },
          "checkout": {
            "internationalCallPermissionHint": {
              "description": "You currently do not have access to the included roaming minutes to and from other countries. To use these, you must have an ID document issued in Switzerland stored in your customer account (passport, ID card, C, B, F, or S permit). If you have such a document, you can have it stored via our support team. You can already use the included roaming data, even without this identification document.",
              "title": "Limited Roaming Features"
            },
            "once": "One-time",
            "roamingOption": "Roaming package",
            "stepLabel": "Completion",
            "success": "Booking completed successfully.",
            "title": "Book roaming"
          },
          "inAdditionToSubscription": "In addition to your subscription:",
          "includedInSubscription": "Included in your subscription:",
          "package": "Option {{index}}",
          "roamingCallHint": {
            "text": "Calls from Switzerland abroad are only included for the following countries: Andorra, Belgium, Denmark, Germany, Faroe Islands, Finland, France, Gibraltar, Greece, Greenland, Guernsey, Ireland, Iceland, Isle of Man, Italy, Jersey, Canada, Liechtenstein, Luxembourg, Malta, Monaco, Netherlands, Norway, Austria, Portugal, San Marino, Sweden, Spain, USA, Vatican City, United Kingdom, Cyprus.",
            "title": "Outgoing Calls From Switzerland"
          },
          "showOption": {
            "active": {
              "callsToAndFromAbroad": "Calls EU/USA",
              "dataUsage": "Data EU/USA",
              "notAllowed": "Currently not available.",
              "notAllowedTooltip": "To use roaming calls, a payment method must be on file and a Switzerland-issued identity document (passport/ID card or foreigner's identity card) must be used during the ID Check.",
              "overspentCalls": "Your international calls are used up and the <0>regular rates</0> apply.",
              "overspentCallsLink": "https://digitalrepublic.ch/wp-content/uploads/2024/05/Preisliste_EN-2.pdf ",
              "remainingData": "<0>{{value}}</0> of <0>{{initial}} MB</0> available",
              "remainingDataGB": "<0>{{value}}</0> of <0>{{initial}} GB</0> available",
              "remainingMin": "<0>{{value}}</0> of <0>{{initial}} min</0> available",
              "runtimeUsage": "<0>{{value}}</0> of <0>{{initial}} days</0> remaining",
              "unlimitedCalls": "Unlimited international calls"
            },
            "flatMobileHint": {
              "notIncluded": "Not included",
              "renewalReminder": "The roaming data volume is renewed on the first of the month.",
              "text": "Because your included data roaming is always renewed on the first of the month, you will receive your roaming data volume on a pro rata basis in your first month.",
              "title": "Partial roaming data volume in your first month"
            },
            "flatMobileTooltip": {
              "example": {
                "description": "Activation on January 15: You will receive 50% of the roaming data volume for January and 100% from February.",
                "title": "Example"
              },
              "monthlyRenewal": {
                "description": "Your roaming data volume is renewed every month on the 1st, regardless of the activation date of your plan.",
                "title": "Monthly renewal"
              },
              "proRataVolume": {
                "description": "In your first month, you will receive your roaming data volume on a pro rata basis.",
                "title": "Pro-rata volume in the first month"
              },
              "title": "Info on the included roaming data volume"
            },
            "inactive": {
              "hint": "Each roaming package is valid for 365 days and is only activated when you are abroad.<br><br>If your plan includes calls and SMS, you can activate telephony and SMS abroad in <0>Calls</0>."
            },
            "ordered": {
              "usage": "Your roaming package is in preparation."
            },
            "ready": {
              "daysLeft": "Still <0>{{days}}</0> of <0>{{initial}} days</0> to activate",
              "daysLeftWithoutTotal": "Still <0>{{days}} days</0> to activate",
              "firstPackageOfUsageZone": {
                "subtitle": "Starts as soon as you are abroad."
              },
              "notFirstPackageOfUsageZone": {
                "subtitle": "Starts as soon as the previous packages for this zone have been used."
              }
            }
          }
        },
        "subscription": {
          "chooseSubscription": "Choose subscription",
          "noSubscription": "No active subscription",
          "options": {
            "changeDisabled": "The subscription options can only be changed once the order is complete.",
            "changeDisabledMissingPaymentMean": "Your subscription can only be changed once you have added a payment method.",
            "changeDisabledPauseReview": "The subscription options can only be changed once you've confirmed or cancelled this pause.",
            "changeDisabledWatchSim": "The subscription options can only be changed once the Watch SIM is activated.",
            "dataRoaming": "Data roaming EU/USA",
            "download": "Download",
            "upload": "Upload"
          },
          "price": {
            "title": "Subscription base price"
          },
          "status": {
            "billingPeriod": {
              "change": "Change",
              "label": "Billing period"
            },
            "cancelPause": "Cancel pause",
            "changeDisabled": "The subscription status can only be changed once the order is complete.",
            "changeDisabledFlatHome": "From {{date}} you can manage the status of your Flat Home subscription. Flat Home has a minimum contract term of 12 months.",
            "changeDisabledWatchSim": "The subscription cannot be paused until the Watch SIM is activated.",
            "inPreparation": "Subscription is being prepared",
            "locked": "Your subscription is blocked",
            "pause": "Pause subscription",
            "pausing": "Pausing on <0>{{date}}</0>",
            "paymentFailed": {
              "text": "Your subscription continues as soon as you have updated <0>your payment method</0>.",
              "title": "Payment failed"
            },
            "title": "Subscription status"
          },
          "successor": "Switches to {{flatName}}",
          "successorOn": "Switches on <0>{{date}}</0> to {{flatName}}",
          "title": "Your subscription"
        },
        "tabs": {
          "abo": "Subscription",
          "details": "Details",
          "disabledHint": {
            "inactive": "You cannot open this tab because you need an active subscription.",
            "lockRequested": "You can open this tab as soon as your subscription is no longer blocked.",
            "numberPorting": "You can manage your subscription as soon as the number porting is complete.",
            "servicePending": "You can open this tab as soon as your subscription is ready."
          },
          "numberPorting": {
            "keepNumberQuestion": "Would you like to keep your current phone number and request porting now?",
            "title": "Number Porting",
            "warning": "You <0>cannot</0> choose this option at a later time."
          },
          "roaming": "Roaming",
          "voice": "Calls"
        },
        "tariff": {
          "autoRenew": "Pause plan",
          "changeDisabledReasons": {
            "flatHome": {
              "hint": "(Flat Home has a minimum contract term of 12 months)",
              "text": "From <strong>{{date}}</strong> onwards, you can pause your Flat Home plan.",
              "title": "Info about pausing"
            }
          },
          "checkout": {
            "aliasNotSaved": "Your plan has been changed, but the subscription name \"{{alias}}\" could not be saved. You can change it again under Details.",
            "aliasSaveFailed": "The subscription name could not be saved. Please try again.",
            "creditText": "(time remaining)",
            "creditTextOthers": "(others)",
            "noProductId": "Please navigate back and select a product.",
            "tariffActivation": {
              "asSuccessor_one": "After the <strong>remaining time of one day</strong> has expired, this plan will be activated automatically:",
              "asSuccessor_other": "After the <strong>remaining time of {{count}} days</strong>, this subscription will be activated automatically:",
              "now_one": "The remaining time of one day will be credited to you. Upon confirmation, your payment method will be charged and the plan will be activated <strong>immediately</strong>:",
              "now_other": "The remaining time of {{count}} days will be credited to you. Upon confirmation, your payment method will be charged and the subscription will be activated <strong>immediately</strong>:",
              "now_zero": "Upon confirmation, your payment method will be charged and the subscription will be activated <strong>immediately</strong>:"
            },
            "watchSimDeactivationHint": "Switching to a data-only plan will <0>deactivate your Watch SIM</0>. Watch SIM is only available with a plan that includes calls and SMS.",
            "watchSimWarning": "Warning"
          },
          "goodToKnow": {
            "inactiveHint": "You can reactivate your plan at any point within 12 months.",
            "missingPaymentMeanHint": "Your plan will continue as soon as you add a <0>payment method</0>.",
            "numberPorting": "Your plan will be activated once the number porting is completed.",
            "warning": "Warning"
          },
          "once": "once",
          "payInterval": "every {{days}} days",
          "serviceIsPendingHint": "Your subscription is being activated. This process may take up to 15 minutes. If you experience longer wait times, please contact customer service.",
          "until": "until",
          "untilRevoke": "until revoke",
          "yourTariff": "Your plan"
        },
        "voiceSettings": {
          "errors": {
            "changeInProgress": "A change to your call settings is already being processed. Please try again later."
          },
          "reasons": {
            "askSupport": "If you have any questions, please contact our support.",
            "costLimitReached": "Cost limit has been exceeded.",
            "creditClassC": "This action is blocked for customers who have not uploaded an ID document issued in Switzerland, or who are not resident in Switzerland.",
            "noActiveVoicePackage": "This function is not available for data-only subscriptions.",
            "noPaymentMean": "No means of payment deposited.",
            "servicePendingBlocked": "Call settings cannot be changed while an order for this SIM is still being processed.",
            "voiceSettingsBlocked": "Some call settings are locked for the following reason:"
          },
          "settings": {
            "adult": {
              "subtitle": "Paid value-added service adult entertainment",
              "title": "Adult content"
            },
            "roaming": {
              "subtitle": "Calls abroad and from Switzerland to abroad are subject to charges according to the <0>rate list</0>.",
              "title": "Roaming and international calls"
            },
            "serviceNumbers": {
              "subtitle": "Chargeable calls to 0906 and 090x numbers",
              "title": "Value-added service number"
            },
            "serviceSMS": {
              "subtitle": "Chargeable value-added service messages",
              "title": "Value-added service SMS"
            },
            "voiceBox": {
              "subtitle": "Missed calls are diverted to voicebox. If you are abroad, this may incur costs.",
              "title": "Voicebox"
            }
          }
        },
        "watchSim": {
          "autoRenewal": {
            "disable": {
              "description_one": "After the <strong>remaining time of one day</strong>, this plan will be paused:",
              "description_other": "After the <strong>period of {{count}} days</strong>, this subscription will no longer be renewed automatically: ",
              "goodToKnowText": "You can activate it again at any time",
              "successMessage": "The plan will be paused."
            },
            "enable": {
              "description": "The following plan continues <strong>every {{count}} days</strong>:",
              "goodToKnowText": {
                "withMainSimAR": "Please note that Watch SIM only works with an active main plan. If your main plan is paused, it will also be resumed as a result."
              },
              "nextBillDescription": "Your Watch SIM will be billed from the next billing month. You pay nothing today.",
              "title": "Reactivate Watch SIM"
            }
          },
          "checkout": {
            "autoRenewal": {
              "hint_one": "The <0>remaining time of one day</0> will be credited to you. Upon confirmation, your payment method will be charged and the subscription will be activated immediately:",
              "hint_other": "The <0>remaining time of {{count}} days</0> will be credited to you. Upon confirmation, your payment method will be charged and the subscription will be activated immediately:",
              "message": "Your plan stays active. You can manage your settings at any time."
            },
            "confirm": "Confirm booking",
            "creditRemainingTime": "Credit (remaining time)",
            "title": "Add Watch",
            "today": "Today"
          },
          "display": {
            "autoRenew": "Pause Watch SIM",
            "creationHelpText": "With this option you can link your smartwatch with your smartphone. Please make sure that your devices can be linked before booking.",
            "linkHelpText": "To link your smartwatch with your smartphone, please follow the instructions on your smartwatch or <0>here</0>.",
            "linkHelpUrl": "https://support.digitalrepublic.ch/en/support/solutions/folders/33000217141",
            "noActiveOption": "No Watch SIM active",
            "pending": "Your Watch SIM will be ready to be activated shortly.",
            "title": "Your Watch SIM",
            "voiceOption": "Voice Option",
            "voiceOptionNeeded": "The Watch SIM can only be booked with an active Flat Mobile plan."
          },
          "status": {
            "activating": "Being prepared",
            "cancelPause": "Cancel pause",
            "changeDisabled": "The Watch SIM status can only be changed once the order is complete.",
            "locked": "Your Watch SIM is blocked",
            "pause": "Pause Watch SIM",
            "pausing": "on <0>{{date}}</0>",
            "title": "Watch SIM status"
          }
        }
      },
      "purchaseIntent": {
        "esim": {
          "button": "Activate eSIM",
          "message": "Activate your eSIM without waiting and start using your plan."
        },
        "physical": {
          "button": "Activate SIM card",
          "defaultAlias": "SIM Card",
          "message": "Once your SIM card has arrived, you can activate it here."
        },
        "status": {
          "onTheWay": "SIM card on its way"
        }
      },
      "sections": {
        "toActivate": "To activate"
      }
    },
    "common": {
      "alerts": {
        "agentLogin": "Logged in as Agent",
        "error": "Action failed.",
        "tryAgain": "Try again"
      },
      "autoRenewal": {
        "dueDate": "Bill due on {{date}}",
        "goodToKnow": "You can pause or cancel your plan at any time.",
        "nextBillTitle": "Your next bill:",
        "successMessage": "Your plan is active again."
      },
      "bills": "Bills",
      "buttons": {
        "abort": "quit",
        "bookOption": "Book a package",
        "cancel": "cancel",
        "change": "change",
        "clearSearch": "Clear search",
        "close": "close",
        "confirm": "confirm",
        "continue": "continue",
        "disable": "disable",
        "enable": "enable",
        "save": "save",
        "showOptions": "show options",
        "skipForLater": "Skip for later",
        "submit": "submit",
        "switch": "switch"
      },
      "checkout": {
        "creditOther": "Credit (other)",
        "nowToPay": "To pay now",
        "paymentMethod": "Payment method",
        "paymentMethodHint": "If you would like to select a different means of payment, please change this in the <0>settings</0> in your account management.",
        "paymentMethodSubtitle": "Already saved means of payment",
        "sum": "Total"
      },
      "device": {
        "attributes": {
          "deviceType": "Device Type",
          "followupPackage": "Follow-up Plan",
          "iccid": "ICCID",
          "mobileSubscription": "Mobile Subscription",
          "openRuntime": "Duration",
          "pin": "PIN",
          "puk": "PUK",
          "roamingDataConsumption": "Roaming Data Consumption",
          "roamingOpenRuntime": "Roaming Duration",
          "roamingStatus": "Roaming Status",
          "simNumber": "SIM Number",
          "simType": "SIM Type",
          "status": "Status",
          "tariff": "Plan",
          "telephoneNumber": "Phone Number",
          "voiceOption": "Voice Option"
        },
        "placeholder": {
          "alias": "My subscription"
        }
      },
      "esim": {
        "install": "Install eSIM",
        "installHint": "Tap the button to install your eSIM.",
        "profile": "eSIM profile"
      },
      "listOfData": {
        "error": "An error occurred while loading.",
        "noMoreData": "All SIM cards have been loaded."
      },
      "nextBill": "Next bill on <0>{{date}}</0>",
      "openBillReason": "You have at least one open bill.",
      "or": "or",
      "phoneNumber": "Phone number",
      "roaming": {
        "countryList": "country list",
        "dialog": {
          "title": "Roaming data zones and countries"
        },
        "zones": {
          "ZONE1": "EU/USA",
          "ZONE2": "Zone 2",
          "ZONE3": "Zone 3",
          "ZONE4": "Roaming services are not available in any other countries.",
          "countries": {
            "ZONE1": "Andorra, Austria, Belgium, Bulgaria, Canada, Croatia, Cyprus, Czech Republic, Denmark, Estonia, Faroe Islands, Finland, France, Germany, Gibraltar, Greece, Greenland, Guernsey, Hungary, Iceland, Ireland, Isle of Man, Italy, Jersey, Latvia, Liechtenstein, Lithuania, Luxembourg, Malta, Monaco, Netherlands, Norway, Poland, Portugal, Puerto Rico, Romania, San Marino, Slovakia, Slovenia, Spain, Sweden, Turkey, United Kingdom, USA, Vatican.",
            "ZONE2": "Albania, Algeria, Australia, Bosnia-Herzegovina, Brazil, Dominican Republic, Egypt, Israel, Kosovo, Macedonia, Mexico, Montenegro, Morocco, Oman, Palestine, Qatar, Serbia, Singapore, South Africa, Thailand, United Arab Emirates.",
            "ZONE3": "Afghanistan, Anguilla, Antigua and Barbuda, Argentina, Armenia, Azerbaijan, Bahamas, Bangladesh, Barbados, Belarus, Benin, Bermuda, Botswana, Brunei Darussalam, Burkina Faso, Cambodia, Cameroon, Cape Verde, Cayman Islands, Chad, Chile, China, Colombia, Congo Democratic Republic, Congo People's Republic, Costa Rica, Cuba, Côte d'Ivoire, Dominica, Ecuador, El Salvador, Fiji, French Guiana, French Polynesia, French West Indies, Georgia, Grenada, Guadeloupe, Guatemala, Guinea, Guinea-Bissau, Guyana, Haiti, Honduras, Hong Kong, India, Indonesia, Iran, Iraq, Jamaica, Japan, Kenya, Kuwait, Kyrgyzstan, Lao People's Democratic Republic, Liberia, Madagascar, Malawi, Malaysia, Mali, Martinique, Mauritius, Mozambique, Nepal, Netherlands Antilles, New Zealand, Nicaragua, Niger, Nigeria, Pakistan, Panama, Paraguay, Peru, Philippines, Republic of Korea, Republic of Moldova, Russian Federation, Rwanda, Réunion, Saint Barthélemy, Saint Kitts and Nevis, Saint Lucia, Saint Martin (French part), Saint Vincent and the Grenadines, Senegal, Seychelles, Sierra Leone, South Sudan, Sri Lanka, Sudan, Taiwan, Trinidad and Tobago, Tunisia, Turks and Caicos Islands, Uganda, Ukraine, Uruguay, Uzbekistan, Vietnam, Virgin Islands (US), Zambia."
          }
        }
      },
      "status": {
        "active": "Active",
        "inactive": "Inactive",
        "notAvailable": "Not available",
        "suspended": "Suspended"
      },
      "stepLabels": {
        "rateSelection": "Plan selection"
      },
      "stepMenuLabel": "Jump to another step",
      "subscriptionCount_one": "{{count}} subscription",
      "subscriptionCount_other": "{{count}} subscriptions",
      "tooltip": {
        "actionNotPossible": {
          "text_one": "You cannot use this function for the following reason:",
          "text_other": "You cannot use this function for the following reasons:",
          "title": "Currently not possible"
        },
        "moreInfo": "More information"
      }
    },
    "documents": {
      "tabItemizedBill": {
        "additionalSelectedNumbers_one": "and {{count}} more phone number selected",
        "additionalSelectedNumbers_other": "and {{count}} more phone numbers selected",
        "btnSearch": "Search",
        "choosePlanAndPeriod": "Select a phone number and a period to view your connection overview.",
        "headline": "Your connection records",
        "noItemizedBillOverview": "There is no connection overview for the last 6 months yet.",
        "onlyOneFilterAllowed": "Only one filter allowed",
        "placeholderPeriods": "Choose a time period",
        "placeholderPlans": "Select your phone number",
        "placeholderSearchTerm": "Search phone number",
        "resultsHeadline": "Search results",
        "subtitle": "Would you like an overview of your phone calls and text messages? Download a PDF summary of your connections made over the last 6 months.",
        "title": "Connection Overview",
        "zipName": "Detailed Call Records - Digital Republic"
      }
    },
    "flatHome": {
      "duration": "12 month term"
    },
    "friendsWithBenefits": {
      "creatingGroup": "Creating group...",
      "error": {
        "fail": "Error creating group"
      },
      "groupName": "New Friends Group",
      "groupOverview": {
        "confirmLeave": "Leave group",
        "discount": "Discount",
        "eligibleProducts": "Subscriptions",
        "groupTitle": "{{name}}'s Friends with Benefits",
        "groupTitleSEnding": "{{name}}' Friends with Benefits",
        "howItWorks": "This Is How It Works",
        "howItWorksModal": {
          "changingSubscriptionAnswer": "The discount will be deducted at checkout. For example, if you sign up for a new subscription or have automatic renewal enabled, the discount valid at that time will apply. If you add a new subscription, it will be immediately taken into account when calculating your discount, so you'll instantly benefit from an even better deal.",
          "changingSubscriptionQuestion": "How does the discount work if I make changes to my subscriptions?",
          "eligibleSubscriptionsAnswer": "Every Flat Mobile cell phone subscription with Digital Republic will be credited to your discount. This also means that you will receive a discount if you have more than one active Flat Mobile subscription on your account.\n\nPlease note that subscriptions are only eligible for the discount if a valid payment method is stored in the corresponding customer account.",
          "eligibleSubscriptionsQuestion": "Which subscriptions are eligible for the discount?",
          "flatMobileInactiveAnswer": "If you don't have an active Flat Mobile plan yet, you can still join a Friends with Benefits group.\n\nHowever, after 30 days without a paid subscription, you will be automatically removed from the group so that the spot becomes available.",
          "flatMobileInactiveQuestion": "What happens if I don't have an active Flat Mobile plan yet?",
          "joinMoreGroupsAnswer": "No, you can only belong to one group at a time. If you want to join another group, you must first leave your current group.",
          "joinMoreGroupsQuestion": "Can I join more than one group?",
          "maxMemberLimitExceededAnswer": "Each group can have up to 15 members. Once your group is full, no more members can join. The invitation link will inform new users that the group has reached its maximum number of members, so you don't have to manage this manually.",
          "maxMemberLimitExceededQuestion": "What happens when my group reaches the maximum number of members?",
          "numberPortingInProgressAnswer": "Good news! If your number is still being transferred to Digital Republic, you can stay in the group until the transfer is complete.\n\nPlease note that the discount will only be applied to your plan once the transfer is complete and your plan becomes active.",
          "numberPortingInProgressQuestion": "What if my number is still being ported?"
        },
        "inactiveWarning": "<0>Warning!</0><br />No active plans. This member will be automatically removed in {{days}} days if no eligible products are added.",
        "inviteFriends": "Invite friends",
        "leaveTribe": "Leave group",
        "leaveTribeConfirmationText": "If you leave this group, you’ll stop receiving your group discount. You can still create a new group or join another one at any time.",
        "leaveTribeConfirmationTitle": "Leave group?",
        "linkCopied": "Link copied!",
        "linkCopyError": "Link could not be copied.",
        "members": "{{count}} member",
        "members_other": "{{count}} members",
        "newFriend": "New friend",
        "onpHint": "The discount will be applied to the subscription after the phone number has been ported.",
        "orderFM": "Order Flat Mobile",
        "share": "Share invitation",
        "sharePanel": {
          "email": "E-mail",
          "subtitle": "Share via...",
          "title": "Share the code and invite your friends"
        },
        "shareSubHeadline": "Do you want to save with me? <br />( ) Yes ( ) No ( ) Maybe",
        "shareText": "At Digital Republic we save up to 30% on unlimited mobile phone subscriptions from CHF 13.",
        "shareTitle": "Become a Friend with Benefits | Digital Republic",
        "status": {
          "discountTitle": "You benefit from a <0>{{percentage}} discount</0>!",
          "fullDescription": "Well done, you have so many friends with benefits that you've reached the <0>group limit</0>.",
          "fullMaxDescription": "Well done, you have so many friends with benefits that you've reached the <0>limit</0>.",
          "fullMaxTitle": "Congratulations! Your group is full and you benefit from a <0>{{percentage}} discount</0>!",
          "fullTitle": "Your group is full and you benefit from a <0>{{percentage}} discount</0>!",
          "maxDiscount": "Congratulations! You and your friends have now reached the <0>largest possible discount</0>.",
          "nextLevel_one": "Add <0>{{count}} more member</0> or device to reach the next level of <1>{{nextPercentage}} discount</1>.",
          "nextLevel_other": "Add <0>{{count}} more members</0> or devices to reach the next level of <1>{{nextPercentage}} discount</1>."
        },
        "subheading": "No matter what brings you together, you’ll save.",
        "tableTitle": "Your friends"
      },
      "joinGroup": {
        "error": {
          "alreadyInGroup": "You are already Friends with Benefits with others. Stay loyal to them or leave the group before joining a new one.",
          "deletedGroup": "These friends with benefits have vanished into thin air. Create a new group or join an existing one.",
          "notFound": "These friends with benefits could not be found. Perhaps there was a typo in the link?",
          "paymentMethod": "Unfortunately, this payment method is not supported.",
          "tribeFull": "Unfortunately, there is no more space here. But you are welcome to start a new Friends with Benefits group!"
        },
        "sucess": "You have joined successfully!"
      },
      "newGroup": {
        "createButton": "Create Group",
        "footer": "Do you already know someone who has a group? Ask for the invitation link and get started!",
        "notificationDescription": "With every additional Flat Mobile plan in your group, the discount increases. Save up to 30% on your Mobile plan.",
        "notificationTitle": "Get up to <0>30% off</0>!",
        "steps": {
          "1": "Set up your group with a single click.",
          "2": "Send, post or share your invitation link however and wherever you like.",
          "3": "Everyone can join <0>and</0> invite others"
        },
        "subtitle": "{{name}}, secure a discount for you and your friends",
        "title": "New Group"
      },
      "welcome": {
        "benefits": {
          "instant": {
            "text": "Activated subscriptions benefit from every new discount level right away.",
            "title": "Benefit right away"
          },
          "saving": {
            "text": "The bigger the group, the higher the discount – up to 30% is possible.",
            "title": "Save together"
          },
          "viral": {
            "text": "Every member can invite others – no matter where you post the link.",
            "title": "Go viral"
          }
        },
        "discountShort": "Your discount: {{discount}}%",
        "flatMobileOne": "Flat Mobile One",
        "flatMobileThree": "Flat Mobile Three",
        "flatMobileTwo": "Flat Mobile Two",
        "greeting": "Welcome!",
        "joinNow": "Join Now",
        "link": "https://digitalrepublic.ch/en/fwb/",
        "nextSteps": "How to secure your benefit",
        "notConvinced": "Any more questions? <0>Learn more about Friends with Benefits and our plans</0>",
        "priceHint": "That gets you the cheapest flat-rate plan for Switzerland for just CHF {{price}} per month! The more plans in the group, the bigger the discount for everyone!",
        "rates": "Our plans",
        "referralCTA": "This gets you mobile plans with no activation fee and no minimum term. With Digital Republic, all without commitment.",
        "slides": {
          "aboutMe": "About me",
          "counter": "{{step}} / {{total}}",
          "goToSlide": "Go to slide {{step}}",
          "lastSlide": {
            "cta": "I'm in!",
            "headline": "It's your turn, take the next step!",
            "notification": {
              "description": "Up to 30% discount for everyone!",
              "title": "More Friends with Benefits"
            },
            "steps": {
              "invite": "Invite more friends",
              "save": "Push the price down even further for you and everyone else."
            },
            "title": "Now it's your turn!"
          },
          "pauseSlides": "Pause",
          "resumeSlides": "Resume",
          "searchingFor": "Looking for:",
          "selectSlide": "Select slide",
          "slide1": {
            "bullet1": "Flexible mobile phone plans with no hidden costs",
            "bullet2": "Everything unlimited in Switzerland",
            "description": "I am Digital Republic – fair, simple, and flexible. No commitment, no hidden costs – with me, you always know where you stand. I am your perfect match if you love freedom and don't want to be tied down.",
            "match": "Customers who love freedom, fairness and progress."
          },
          "slide2": {
            "bullet1": "Everything unlimited in Switzerland, including 5G",
            "bullet2": "3 GB roaming data in the EU/USA zone",
            "bullet3": "30 minutes of roaming calls in the EU/USA zone",
            "description": "I am the down-to-earth plan. A little roaming, no frills – just what you really need. I am your perfect match if Switzerland is enough for you, with a small allowance for trips abroad.",
            "match": "The thrifty and the minimalists",
            "title": "Flat Mobile One | CHF 13.–"
          },
          "slide3": {
            "bullet1": "Unlimited everything in Switzerland, including 5G",
            "bullet2": "20 GB roaming data in the EU/USA zone",
            "bullet3": "100 minutes of roaming calls in the EU/USA zone",
            "description": "I'm as spontaneous as your everyday life, which sometimes takes you beyond Switzerland. I'm your plan if you love high speed, don't want to be tied down, but still want to take a quick look across the border (surf or make calls).",
            "match": "The spontaneous and the easy-going",
            "title": "Flat Mobile Two | CHF 18.–"
          },
          "slide4": {
            "bullet2": "50 GB roaming data in the EU/USA zone",
            "bullet3": "Unlimited roaming calls in the EU/USA zone",
            "description": "I'm for those who want more – with no upper limit. Just get started without thinking twice. With me, you get unlimited high speed in Switzerland and can surf and make calls beyond the country's borders. I'm THE subscription with no compromises.",
            "match": "The free and the uncompromising",
            "title": "Flat Mobile Three | CHF 25.–"
          },
          "slide5": {
            "bullet1": "Lets you keep your mobile number",
            "bullet2": "Cancels your contract with your old provider for you.",
            "description": "Breakups are never easy. That's why I'll help you get over your relationship with your old provider. All I need is your number and the name of your ex (provider). 😉",
            "match": "The simple break-up",
            "title": "Number porting"
          }
        },
        "steps": {
          "benefit": "Get up to 30% off",
          "order": "Choose your Flat Mobile phone plan",
          "register": "Join Friends with Benefits"
        },
        "stories": "Get to know Digital Republic",
        "textFlatMobileOne": "CH unlimited, 3 GB & 30 min Roaming",
        "textFlatMobileThree": "CH unlimited, 50 GB & unlimited min Roaming",
        "textFlatMobileTwo": "CH unlimited, 20 GB & 100 min Roaming",
        "unknown": "someone",
        "youWereInvited": "You lucky devil! <0>{{user}}</0> invited you to Friends with Benefits."
      }
    },
    "layout": {
      "header": {
        "menu": {
          "logout": "Log out"
        }
      },
      "menu": {
        "bottomNav": {
          "ariaLabel": "Bottom navigation"
        },
        "burger": {
          "close": "Close navigation",
          "open": "Open navigation"
        },
        "items": {
          "account": "Account",
          "accountAriaLabel": "User Account",
          "cockpit": "Cockpit",
          "documentsAriaLabel": "Bills and documents",
          "friendsWithBenefitsShort": "FwB",
          "mySubscriptions": "Plans"
        },
        "sidebar": {
          "ariaLabel": "Main navigation",
          "collapse": "Collapse navigation",
          "expand": "Expand navigation"
        }
      },
      "skipToContent": "Skip to main content",
      "table": {
        "pageNumberComboBox": {
          "entriesPerPage": "Entries per page"
        },
        "pagination": {
          "ariaLabel": "Pagination"
        },
        "sortBy": "Sort by {{title}}"
      },
      "tiles": {
        "activeSim": {
          "internationalCalls": "Calls EU/USA",
          "notAvailable": "not available",
          "roamingCallUsage": "{{remaining}} / {{available}} min available",
          "roamingUsage": "{{remaining}} / {{available}} MB available",
          "roamingUsageGB": "{{remaining}} / {{available}} GB available"
        },
        "addDevice": {
          "button": "Add plan now",
          "title": "Add a new plan!"
        },
        "complete": "Complete",
        "evnCard": {
          "button": "View now",
          "text": "Understand your bills better with a detailed overview of your calls and SMS.",
          "title": "Overview"
        },
        "inactive": {
          "activateSubscriptionButton": "Activate subscription",
          "activateSubscriptionText": "Select a new plan under \"Activate plan\" for this device.",
          "activateText": "Select a new plan under <0>Manage plan</0> for this device.",
          "beginsAfterID": "Begins after ID check",
          "noPackageActive": "No active data package",
          "noSubscriptionActive": "no subscription activated"
        },
        "numberPorting": {
          "numberBeingTransferred": "Number is being transferred",
          "sections": {
            "dateBeingIdentified": "Porting date is set",
            "done": "Porting is completed",
            "known": "Porting takes place on {{val}}",
            "missingInformation": "Information is missing",
            "requested": "Porting has been requested",
            "simActivationPending": "SIM activation pending"
          }
        },
        "pending": {
          "chipLabel": "Being processed",
          "couldNotRenewTitle": "Could not be continued.",
          "inProcess": "Your subscription is being prepared",
          "missingPaymentMethod": "Your plan could not be continued, because no payment method is on file."
        },
        "promoItemizedBill": {
          "activateNow": "View now",
          "heading": "Connection overview",
          "text": "Understand your bills better with a detailed overview of your calls and SMS."
        },
        "qrCodeTile": {
          "activateText": "Scan this QR code with your smartphone to install your eSIM.",
          "inProcessText": "Your eSIM profile will be generated. This takes a few minutes.",
          "instructionsLink": "https://support.digitalrepublic.ch/en/support/solutions/articles/33000277288-how-do-i-activate-an-esim-on-my-smartphone-",
          "qrPerEMail": "The corresponding QR code will then be displayed here and sent to you by email.",
          "showInstructions": "See instructions"
        },
        "statusChip": {
          "pausing": "Being paused"
        },
        "suspendedSim": {
          "yourSimSuspended": "Your SIM has been suspended."
        }
      }
    },
    "loading": "Loading...",
    "mobileAbo": {
      "name": " Roaming",
      "roamingGoodToKnow": "The roaming data volume included in your mobile subscription belongs to Zone 1 and will always be used first, even if you have already activated additional roaming options in the same zone.",
      "roamingGoodToKnowMinuteAllowance": "Your minute allowance is updated with a delay of up to 24 hours. Any call minutes that exceed your allowance will be charged per minute."
    },
    "my-subscriptions": {
      "addSubscription": "Add subscription",
      "viewToggle": {
        "list": "List view",
        "tiles": "Tile view"
      }
    },
    "personalDataOnboarding": {
      "headline": "Complete your profile"
    },
    "subscription-change": {
      "currentTariffLabel": "Current",
      "heading": "Change plan",
      "steps": {
        "checkout": {
          "label": "Checkout"
        }
      }
    },
    "user-account": {
      "billingAccounts": {
        "add": "Add recipient",
        "bulkMove": {
          "description": "Move several subscriptions from one billing recipient to another in one go.",
          "deselectAll": "Deselect all subscriptions",
          "error": "We could not move the subscriptions. Please try again.",
          "selectAll": "Select all subscriptions",
          "selectHeadline": "1. Select subscriptions",
          "selected": "Selected subscriptions",
          "success": "The subscriptions have been moved.",
          "targetDescription": "After the move, the selected subscriptions will be assigned to this billing recipient.",
          "targetHeadline": "2. Target billing recipient",
          "title": "Bulk move"
        },
        "details": {
          "address": "Address",
          "note": "Note",
          "postalAddress": "Postal address"
        },
        "empty": "You have not added any billing recipients yet.",
        "expand": "Show details",
        "modal": {
          "create": "Create recipient",
          "createSuccess": "The billing recipient has been created.",
          "createTitle": "Add billing recipient",
          "description": "Enter the name, address, email and reference for this billing recipient.",
          "editAddress": "Edit",
          "editTitle": "Edit billing recipient",
          "error": "We could not save the billing recipient. Please try again.",
          "fields": {
            "additionalAddress": "Address supplement",
            "alias": "Label",
            "aliasHint": "Shown in the overview after the billing recipient number so you can identify the recipient faster.",
            "city": "City",
            "companyName": "Company name",
            "companyOrNameRequired": "Please enter a company name or a name.",
            "email": "Email address",
            "emailHeadline": "Email*",
            "firstName": "First name",
            "lastName": "Last name",
            "note": "Add a note",
            "referenceHeadline": "Reference*",
            "zip": "Postcode"
          },
          "updateSuccess": "The billing recipient has been saved."
        },
        "move": {
          "source": "Source",
          "submit": "Move subscriptions",
          "target": "Select target billing recipient"
        },
        "moveModal": {
          "error": "We could not move the subscription. Please try again.",
          "subscription": "Subscription to move",
          "success": "The subscription has been moved.",
          "title": "Move subscription"
        },
        "picker": {
          "listHeadline": "Your billing recipients",
          "title": "Select billing recipient"
        },
        "reference": "Reference",
        "select": {
          "label": "Billing recipient"
        },
        "subscriptions": {
          "empty": "No subscriptions are assigned to this billing recipient.",
          "headline": "Assigned subscriptions",
          "move": "Move subscription",
          "moveSelected_one": "Move {{count}} subscription",
          "moveSelected_other": "Move {{count}} subscriptions"
        }
      },
      "inbox": {
        "contactlanguage": "Contact language",
        "marketingSubtitle": "I would like to receive special offers by email.",
        "marketingTitle": "Additional information",
        "noLanguageSet": "No language selected.",
        "saveError": "We could not save your changes. Please try again."
      },
      "paymentMethods": {
        "addPaymentMethod": "Add",
        "cancel": "cancel",
        "change": "change",
        "changeSuccessAlert": "Payment method has been changed successfuly.",
        "confirmDelete": "I confirm that I wish to irrevocably delete my means of payment",
        "delete": "delete",
        "deletePaymentmean": "Delete payment mean",
        "deleteSuccessAlert": "Your payment method has been deleted successfully.",
        "errorAlerts": {
          "generalErrorAlert": "Your payment method could not be deleted. Please try again or contact support.",
          "openBill": "Your payment means could not be deleted as you have one or more open invoices.",
          "outstandingCharges": "Your means of payment could not be deleted because the billing of your costs has not yet been completed. If you have any questions, please contact support.",
          "payAsYouGo": "Your means of payment could not be deleted because the billing of your costs has not yet been completed. If you have any questions, please contact support.",
          "serviceSettingsOn": "Your payment method could not be deleted. Your account has costs associated with them that have not yet been billed. If you have any questions, please contact support."
        },
        "headline": "Your payment methods",
        "invoice": "Invoice",
        "noPaymentMethod": "You have not saved any means of payment.",
        "requestPaymentViaInvoice": "If you would like to request payment by invoice, please follow <0>this link</0>.",
        "requestPaymentViaInvoiceLink": "https://support.digitalrepublic.ch/en/support/tickets/new?ticket_form=firmenkunden_%2F_business_client",
        "title": "Payment methods"
      },
      "personalDetails": {
        "address": "Address",
        "changeSuccess": "Personal data saved successfully.",
        "companyData": {
          "editTitle": "Company information",
          "title": "Company data"
        },
        "dateOfBirth": "Date of birth",
        "loginData": {
          "accountLocked": "Your access has been blocked for 30 minutes. Please try again later or reset your password.",
          "currentEmail": "Current email address",
          "currentEmailError": "Invalid email. Please check your input.",
          "currentPassword": "Current Password",
          "emailChangeSuccess": "Email address successfully changed.",
          "emailInUseError": "It seems that this email is already in use, please use a different one.",
          "emailInvalid": "Email address not valid.",
          "newEmail": "Enter new email address",
          "newPassword": "New Password",
          "passwordChangeSuccess": "Password successfully changed.",
          "passwordEnter": "Enter password",
          "passwordError": "Invalid password. Please check your input.",
          "passwordTitle": "Your password"
        }
      },
      "security": {
        "2fa": {
          "alerts": {
            "appSetupSuccess": "App verification successfully saved.",
            "smsSetupSuccess": "SMS verification successfully saved."
          },
          "changeOption": "Change 2FA log in method",
          "changePhonenumber": {
            "error": "The phone number is not valid. Please try again.",
            "text": "You are currently using <0>{{phoneNumber}}</0> for 2FA. If you would like to change your 2FA to a new number, please provide the phone number where you would like to receive your verification code.",
            "title": "Change telephone number"
          },
          "confirmStandard": {
            "error": "We could not remove your 2FA. Try again.",
            "steps": {
              "2": {
                "title": "Confirm with your name that you understand the risks of deactivating 2FA."
              }
            },
            "subtitle": "Deactivate and continue with standard Log in",
            "success": "Your 2FA was removed.",
            "text1": "To confirm the deactivation of your 2FA settings, please sign with your name below.",
            "text2": "Make sure to understand that your account will not be as safe as it should be.",
            "text3": "Your recovery codes will become obsolete after deactivating 2FA. You can get new codes if you activate the settings again later."
          },
          "description": "You can secure your account with 2FA.",
          "disabledBecauseMagicLink": "Not possible with email-link login enabled",
          "initialSetup": {
            "title": "2FA option settings"
          },
          "method": {
            "app": "Authenticator App"
          },
          "modal": {
            "description": "Please enter your 2FA code below to verify yourself.",
            "error": "The code is not valid. Please try again.",
            "foundYourCode": "Found your code?",
            "recoveryCode": "Recovery code",
            "recoveryCodeDescription": "If you have lost access to your 2FA device, you can use a recovery code to log in. Please keep your recovery codes in a safe place.",
            "recoveryTitle": "Enter your recovery code",
            "success": "Your code is valid.",
            "titleApp": "Enter the verification code from your Authenticator App",
            "titleSms": "Enter the verification code from your SMS",
            "unableToUse": "Unable to use verification code?",
            "useUniqueCode": "Use recovery code"
          },
          "qrCode": {
            "description": "Scan the QR Code or copy your key with additional devices or Authenticator Apps. This is particularly useful for customers that share their account.",
            "title": "QR Code for 2FA App"
          },
          "readMore": "Here you can find out more.",
          "readMoreUrl": "https://support.digitalrepublic.ch/en/support/solutions/articles/33000290331",
          "title": "Two-factor authentication (2FA)"
        },
        "buttons": {
          "activate": "Activate",
          "back": "Back",
          "verify": "Verify"
        },
        "magicLink": {
          "description": "When enabled, you can sign in with a secure email link instead of your password.",
          "disabledBecauseTwoFactor": "Not possible with 2FA enabled",
          "saveError": "Your setting could not be saved. Please try again.",
          "saveSuccess": "Your setting has been saved.",
          "title": "Sign in via email link",
          "toggleTitle": "Allow sign-in via email link"
        }
      },
      "tabs": {
        "billingRecipients": "Billing recipients",
        "inbox": "Inbox",
        "paymentMethods": "Payment methods",
        "security": "Login"
      },
      "title": "User account"
    }
  },
  "translation": {
    "2fa": {
      "setup": {
        "options": {
          "authenticatorApp": {
            "title": "Authenticator App"
          },
          "login": {
            "title": "Standard login"
          },
          "not-recommended": "Not recommended",
          "secure": "Secure",
          "sms": {
            "title": "SMS Verification"
          },
          "very-secure": "Very secure"
        }
      }
    },
    "Common": {
      "checkout": {
        "dueOn": "due on {{date}}",
        "summary": "Summary",
        "thereafter": "Thereafter"
      },
      "companyName": "Digital Republic AG",
      "days": "days",
      "friendsWithBenefits": {
        "businessCustomer": "Business customers cannot participate in Friends with Benefits."
      },
      "generalForm": {
        "error": {
          "genericError": "Something went wrong. If the error persists, please try again in a private browsing window.",
          "genericRegexError": "Please enter a valid value"
        },
        "fields": {
          "email": {
            "label": "Email address"
          },
          "password": {
            "label": "Password"
          }
        },
        "validation": {
          "emailNotValid": "Please enter a valid email address",
          "emailRequired": "Please enter an email address",
          "passwordRequired": "Please enter a password"
        }
      },
      "label": {
        "back": "back",
        "backToLogin": "Back to sign in",
        "cancel": "Cancel",
        "change": "Change",
        "complete": "complete",
        "continue": "Continue",
        "delete": "Delete",
        "finish": "Complete",
        "forward": "next",
        "gotIt": "Got it",
        "manage": "Manage",
        "name": "Name",
        "optional": "(optional)",
        "period": "Period",
        "personalDetails": "Personal details",
        "price": "Price",
        "removeItem": "Remove {{label}}",
        "save": "Save",
        "subscriptionName": "Subscription name",
        "toShop": "Go to shop"
      },
      "language": "Language",
      "links": {
        "privacyPolicy": "https://digitalrepublic.ch/en/privacy/",
        "rates": "https://digitalrepublic.ch/en/tariff-overview/",
        "terms&Conditions": "https://digitalrepublic.ch/en/terms-conditions/"
      },
      "logoName": "Digital Republic",
      "nothingFound": "Nothing found.",
      "products": {
        "esim": "eSIM",
        "friendsWithBenefits": "Friends with Benefits",
        "simCard": "SIM card",
        "watchSim": "Watch SIM"
      },
      "requirementStatus": {
        "met": "fulfilled",
        "notMet": "not fulfilled yet"
      },
      "selected": "selected",
      "stepStatus": {
        "done": "done",
        "in-progress": "in progress",
        "to-be-done": "to do"
      },
      "support": "Support",
      "tariff": {
        "365days": "365 days",
        "dataTelephonySmsCH": "Data, Calls & SMS CH",
        "international": "International",
        "mbitMax": "Mbit/s max.",
        "options": "Plan options",
        "unlimited": "Unlimited",
        "unlimitedLowercase": "unlimited",
        "volumeGb": "{{volume}} GB"
      }
    },
    "Content": {
      "goodToKnow": "Good to know",
      "periods": "Periods"
    },
    "Error": {
      "404": {
        "backToThePortal": "Back to the portal",
        "text": "Oops, this page doesn't seem to exist. We're sorry you can't find what you're looking for. Luckily, you can go straight back to the customer portal here.",
        "title": "Error 404"
      },
      "agentLogin": {
        "failed": "Login didn't work. Please try again."
      },
      "eSimError": "eSIM information could not be loaded. Please try again later.",
      "payment": {
        "expired": "This card cannot be charged as its expiry date has passed.",
        "expiredZero": "This card cannot be charged as its expiry date has passed.",
        "fail": "Your payment method could not be charged.",
        "failZero": "Your payment method could not be deposited.",
        "notValid": "This card number is invalid. Please check your input and try again.",
        "pleaseCheckData": "Please check your data or contact the provider of your payment method.",
        "pleaseCheckInput": "Please check your input or try a different payment method."
      },
      "roamingError": "Roaming data could not be loaded. Please try again later."
    },
    "Footer": {
      "customerNumber": "Customer number:",
      "customerPortal": {
        "label": "Customer portal"
      },
      "dataProtection": {
        "label": "Privacy Statement"
      },
      "disclaimer": {
        "label": "Disclaimer",
        "url": "https://digitalrepublic.ch/en/disclaimer-intellectual-property/"
      },
      "imprint": {
        "label": "Imprint",
        "url": "https://digitalrepublic.ch/en/imprint/"
      },
      "linksNavAriaLabel": "Footer links",
      "partnerPortal": {
        "label": "Partner portal"
      },
      "privacySettings": {
        "label": "Privacy Settings"
      },
      "socialLinksNavAriaLabel": "Social media links",
      "support": {
        "url": "https://support.digitalrepublic.ch/"
      },
      "termsConditions": {
        "label": "Terms and Conditions"
      },
      "website": {
        "label": "Website",
        "url": "https://digitalrepublic.ch/en/"
      }
    },
    "Header": {
      "welcomeHeadline": "Welcome to the Customer Portal"
    },
    "Icons": {
      "connection": "Connection",
      "speed": "Speed"
    },
    "Languages": {
      "english": "English",
      "french": "French",
      "german": "German",
      "language": "language"
    },
    "Onboarding": {
      "sections": {
        "checkout": {
          "acceptTerms": "Yes, I agree to the <0>terms and conditions</0> and would like to complete my order.",
          "alreadyAddedPaymentData": "Payment method already added.",
          "basketErrors": {
            "basketReloaded": "Your order could not be completed and has been reloaded. Please check the details and complete your order again.",
            "iccidMissing": "No SIM card is assigned to your order. Please enter your SIM card again.",
            "mnpDataMissing": "Your number porting details are missing. Please enter them again.",
            "totalAmountChanged": "The total amount of your order has changed. Please check the updated amount and complete your order again."
          },
          "billingAccount": {
            "description": "Please choose an existing billing recipient or add a new one.",
            "editHint": "Want to edit an existing billing recipient? You can do that under <0>Billing recipients</0>.",
            "title": "Billing"
          },
          "billingPeriod": {
            "description": "With yearly payment, one month is free.",
            "freeMonthBadge": "1 month free",
            "monthly": "Monthly",
            "title": "Prefer to pay yearly?",
            "yearly": "Yearly"
          },
          "choosePayment": "Add a payment method for this payment. Please ensure that 3D Secure is enabled for your credit card.",
          "loading": "Your order is being processed.",
          "noCharge": "For security reasons, a payment method must be provided to activate your subscription. If you have already paid for your subscription, we will not charge your payment method.",
          "paymentData": "Payment data",
          "subtitleWhileHandling": "Your payment is being processed, one moment please!",
          "summary": {
            "billingPeriod": "{{days}} days",
            "callsTitle": "Calls EU/USA",
            "callsVolumeMinutes": "{{volume}} min.",
            "changeRate": "edit",
            "credit": "Credit",
            "dataRoamingTitle": "EU/USA data roaming",
            "defaultNames": {
              "dataPlan04": "My Flat 0.4",
              "dataPlan1": "My Flat 1",
              "dataPlan10": "My Flat 10",
              "dataPlan2000": "My Flat 2000",
              "dataPlan300": "My Flat 300",
              "dataPlan50": "My Flat 50",
              "flatMobileOne": "My Flat Mobile One",
              "flatMobileThree": "My Flat Mobile Three",
              "flatMobileTwo": "My Flat Mobile Two",
              "homeInternet4G": "Home Internet 4G",
              "homeInternet5G": "Home Internet 5G"
            },
            "deviceName": "Device name",
            "deviceNamePlaceholder": "Sarah's iPhone",
            "deviceType": "Device type",
            "discount": "Discount",
            "durationDays_one": "{{count}} day contract term",
            "durationDays_other": "{{count}} days contract term",
            "durationMonths_one": "{{count}} month contract term",
            "durationMonths_other": "{{count}} months contract term",
            "errorDeviceName": "Please enter a valid device name (min. 3 characters).",
            "errorDeviceType": "Please select a device type.",
            "esimHintText": "Your eSIM will be available in the portal after your identity has been verified.",
            "internationalRestriction": "A Switzerland-issued identity document (passport/ID card or foreigner's identity card) must be used during the ID Check to use roaming calls.",
            "newNumberHint": "You will receive a new phone number.",
            "newNumberTitle": "New phone number",
            "nextDueOn": "next due {{date}}",
            "numberPortingIncluded": "with number porting",
            "numberPortingNotIncluded": "without number porting",
            "payOnce": "Pay <0>now</0>",
            "payOnceValue": "Pay <0>now</0> {{total}}",
            "payReoccuring": "Pay <0>every {{days}} days</0>",
            "portedNumberHint": "This phone number will be carried over.",
            "portedNumberTitle": "Existing phone number",
            "recurringCaption": "every {{days}} days",
            "startingAfterPorting": "After the number porting",
            "startingOn": "starting {{date}}",
            "subtotal": "Subtotal",
            "switzerlandDataOnlyTitle": "5G data",
            "taxIncluded": "incl. 8.1% VAT",
            "total": "Total",
            "until_date": "(until <0>{{date}}</0>)",
            "voiceOptionIncluded": "with Voice Option",
            "voiceOptionNotIncluded": "without Voice Option"
          }
        },
        "number-porting": {
          "afterContractEnds": "After the end of the contract",
          "beforeContractEnds": "Early termination of the contract",
          "chooseWishDate": "Choose wish date",
          "completed": "Number porting completed",
          "cost-warning": "Your provider may charge you additional fees. The amount is set by your provider and charged to you.",
          "currentContractType": "Current contract type",
          "currentNumber": "Current phone number",
          "currentProvider": "Current provider",
          "hintTitle": "Note",
          "msisdnAlreadyInUse": "The phone number already exists in the system and cannot be registered.",
          "msisdnSuspended": "The phone number suspended and cannot be ported.",
          "numberFormat": "Phone number should be entered in the format +41 (0) xx xxx xx xx.",
          "placeholder": {
            "currentNumber": "`+41 (0) __ ___ __ __",
            "currentProvider": "Choose your provider",
            "wishDate": "YYYY-MM-DD"
          },
          "postpaid": "Subscription (monthly invoice)",
          "prepaid": "Prepaid",
          "recommended": "recommended",
          "steps": "We will take the necessary steps to transfer your phone number. You do not have to cancel the contract with your previous provider yourself.",
          "subHeadline": "In order for us to request the transfer of your phone number from your previous provider to us, please provide us with some details. Don't worry, the porting will happen only if you wish it to.",
          "termination": "Termination",
          "title": "Number porting"
        },
        "personal-details": {
          "disabledFieldsHint": "If you wish to change the inactive fields of your personal details, you may contact our <0>support team</0>.",
          "form": {
            "formOfAddress": {
              "mr": "Mr.",
              "mrs": "Ms.",
              "other": "Not specified"
            },
            "hint": {
              "firstName": "Name as per your ID, including middle names",
              "lastName": "Name as per your ID, including all last names"
            },
            "label": {
              "addressSupplement": "Address suffix",
              "city": "City",
              "company-street": "Street (company headquarters)",
              "country": "Country",
              "dateOfBirth": "Date of birth*",
              "firstName": "First name (as it appears on your ID)",
              "formOfAddress": "Form of address",
              "houseNumber": "No.",
              "isBusinessAccount": "I use this account for business",
              "lastName": "Last name (as it appears on your ID)",
              "organizationForm": "Company type",
              "organizationId": "Company ID",
              "organizationName": "Company name",
              "phone": "Phone number for queries",
              "street": "Street",
              "zip": "Postcode"
            },
            "legalForms": {
              "1": "Sole proprietorship",
              "10": "Foundation",
              "11": "Public corporation",
              "2": "Simple partnership",
              "3": "General partnership",
              "4": "Limited partnership",
              "5": "AG",
              "6": "GmbH",
              "7": "Partnership limited by shares",
              "8": "Cooperative",
              "9": "Association"
            },
            "placeholder": {
              "dateOfBirth": "Date of birth (DD.MM.YYYY)",
              "organizationId": "Company ID (UID)"
            },
            "validation": {
              "organizationId": "Please check the entered UID."
            }
          },
          "friendsWithBenefitsPopUp": {
            "cta1": "Create private account",
            "cta2": "Leave group",
            "text2": "If you set up a business account, you will be removed from the group.",
            "text3": "If you are a business customer and would still like to benefit from volume discounts, please contact our support or sales team.",
            "title": "Attention!"
          }
        },
        "rate-selection": {
          "dontTakeNumber": "<strong>No</strong>, I want a <strong>new</strong> phone number.",
          "download": "Download",
          "mbitPerSecond": "{{value}} Mbit/s",
          "numberPortingHint": "You <0>cannot</0> request it at a later stage.",
          "perMonth": "CHF per month",
          "prechargedRateHint": "You are welcome to adjust this plan after the contract period in the customer portal.",
          "roamingVolumeWithCalls": "{{volume}} GB + {{minutes}} min.",
          "roamingVolumeWithUnlimitedCalls": "{{volume}} GB + ∞ min.",
          "roamingZone": "in EU/USA",
          "tabs": {
            "dataOnly": "Data-only",
            "mobileAbos": "Mobile Abos"
          },
          "tariffHint": "All our plans include <1>unlimited</1> data <0>within Switzerland</0>.",
          "upload": "Upload",
          "yesTakeNumber": "<strong>Yes</strong>, I want to take my <strong>current</strong> phone number with me."
        },
        "sim-selection": {
          "dunningProcessOpenText": "You can't add any new plans right now because your account is in the dunning process. Please settle any outstanding invoices to proceed.",
          "homepageLink": "https://digitalrepublic.ch/en/",
          "noSimCardText": "You need to order a SIM card and have it delivered to activate it.",
          "noSimCardTitle": "Don't have a SIM card yet?",
          "shopLink": "https://digitalrepublic.ch/en/shop/?utm_source=aax_dr&utm_medium=reorder_link&utm_campaign=aax_reorder&utm_term=adddevice",
          "upgradeSimLimit": "expand limit",
          "upgradeSimLimitLink": "https://support.digitalrepublic.ch/en/support/solutions/articles/33000287898-how-can-i-increase-the-maximum-number-of-sims"
        },
        "sim-verification": {
          "hint": {
            "header": "SIM and PUK numbers",
            "text": "You will find your SIM number (ICCID) and your PUK printed on your SIM card."
          },
          "iccid": {
            "helpHint": "Where can I find it?",
            "label": "Your SIM number",
            "placeholder": "Enter your SIM number",
            "validation": {
              "badFormat": "Please enter your 20-digit SIM number.",
              "invalid": "The entered SIM number could not be assigned."
            }
          },
          "puk": {
            "label": "Your PUK",
            "placeholder": "Enter your PUK",
            "validation": {
              "badFormat": "Please enter your 8-digit PUK.",
              "rejected": "Entered PUK does not appear to be correct."
            }
          },
          "scanner": {
            "button": "Scan barcode",
            "cameraError": "Could not open camera. Please check your camera permissions.",
            "hint": "Hold the barcode on your SIM card inside the marked area.",
            "noBarcode": "No barcode detected. Please try again.",
            "scan": "Scan now",
            "scanning": "Scanning…",
            "title": "Scan SIM number"
          },
          "simAliasFlatHome": "My Flat Home",
          "subtitle": "SIM verification subtitle"
        }
      }
    },
    "Tile": {
      "label": {
        "activateSim": "activate\nSIM Card"
      }
    },
    "billingActionBlocked": {
      "text": "Due to an ongoing bill run or your account settings, billing recipients can't be created or edited and subscriptions can't be moved right now. A bill run can take up to 24 hours. Please try again later.",
      "title": "Changes currently not possible"
    },
    "clipboardField": {
      "copy": "Copy"
    },
    "countries": {
      "ABW": "Aruba",
      "AFG": "Afghanistan",
      "AGO": "Angola",
      "AIA": "Anguilla",
      "ALA": "Åland Islands",
      "ALB": "Albania",
      "AND": "Andorra",
      "ARE": "United Arab Emirates",
      "ARG": "Argentina",
      "ARM": "Armenia",
      "ASM": "American Samoa",
      "ATA": "Antarctica",
      "ATF": "French Southern Territories",
      "ATG": "Antigua and Barbuda",
      "AUS": "Australia",
      "AUT": "Austria",
      "AZE": "Azerbaijan",
      "BDI": "Burundi",
      "BEL": "Belgium",
      "BEN": "Benin",
      "BES": "Bonaire, Sint Eustatius and Saba",
      "BFA": "Burkina Faso",
      "BGD": "Bangladesh",
      "BGR": "Bulgaria",
      "BHR": "Bahrain",
      "BHS": "Bahamas",
      "BIH": "Bosnia and Herzegovina",
      "BLM": "Saint Barthélemy",
      "BLR": "Belarus",
      "BLZ": "Belize",
      "BMU": "Bermuda",
      "BOL": "Bolivia (Plurinational State of)",
      "BRA": "Brazil",
      "BRB": "Barbados",
      "BRN": "Brunei Darussalam",
      "BTN": "Bhutan",
      "BVT": "Bouvet Island",
      "BWA": "Botswana",
      "CAF": "Central African Republic",
      "CAN": "Canada",
      "CCK": "Cocos (Keeling) Islands",
      "CHE": "Switzerland",
      "CHL": "Chile",
      "CHN": "China",
      "CIV": "Côte d'Ivoire",
      "CMR": "Cameroon",
      "COD": "Congo, Democratic Republic of the",
      "COG": "Congo",
      "COK": "Cook Islands",
      "COL": "Colombia",
      "COM": "Comoros",
      "CPV": "Cabo Verde",
      "CRI": "Costa Rica",
      "CUB": "Cuba",
      "CUW": "Curaçao",
      "CXR": "Christmas Island",
      "CYM": "Cayman Islands",
      "CYP": "Cyprus",
      "CZE": "Czechia",
      "DEU": "Germany",
      "DJI": "Djibouti",
      "DMA": "Dominica",
      "DNK": "Denmark",
      "DOM": "Dominican Republic",
      "DZA": "Algeria",
      "ECU": "Ecuador",
      "EGY": "Egypt",
      "ERI": "Eritrea",
      "ESH": "Western Sahara",
      "ESP": "Spain",
      "EST": "Estonia",
      "ETH": "Ethiopia",
      "FIN": "Finland",
      "FJI": "Fiji",
      "FLK": "Falkland Islands (Malvinas)",
      "FRA": "France",
      "FRO": "Faroe Islands",
      "FSM": "Micronesia (Federated States of)",
      "GAB": "Gabon",
      "GBR": "United Kingdom of Great Britain and Northern Ireland",
      "GEO": "Georgia",
      "GGY": "Guernsey",
      "GHA": "Ghana",
      "GIB": "Gibraltar",
      "GIN": "Guinea",
      "GLP": "Guadeloupe",
      "GMB": "Gambia",
      "GNB": "Guinea-Bissau",
      "GNQ": "Equatorial Guinea",
      "GRC": "Greece",
      "GRD": "Grenada",
      "GRL": "Greenland",
      "GTM": "Guatemala",
      "GUF": "French Guiana",
      "GUM": "Guam",
      "GUY": "Guyana",
      "HKG": "Hong Kong",
      "HMD": "Heard Island and McDonald Islands",
      "HND": "Honduras",
      "HRV": "Croatia",
      "HTI": "Haiti",
      "HUN": "Hungary",
      "IDN": "Indonesia",
      "IMN": "Isle of Man",
      "IND": "India",
      "IOT": "British Indian Ocean Territory",
      "IRL": "Ireland",
      "IRN": "Iran (Islamic Republic of)",
      "IRQ": "Iraq",
      "ISL": "Iceland",
      "ISR": "Israel",
      "ITA": "Italy",
      "JAM": "Jamaica",
      "JEY": "Jersey",
      "JOR": "Jordan",
      "JPN": "Japan",
      "KAZ": "Kazakhstan",
      "KEN": "Kenya",
      "KGZ": "Kyrgyzstan",
      "KHM": "Cambodia",
      "KIR": "Kiribati",
      "KNA": "Saint Kitts and Nevis",
      "KOR": "Korea, Republic of",
      "KWT": "Kuwait",
      "LAO": "Lao People's Democratic Republic",
      "LBN": "Lebanon",
      "LBR": "Liberia",
      "LBY": "Libya",
      "LCA": "Saint Lucia",
      "LIE": "Liechtenstein",
      "LKA": "Sri Lanka",
      "LSO": "Lesotho",
      "LTU": "Lithuania",
      "LUX": "Luxembourg",
      "LVA": "Latvia",
      "MAC": "Macao",
      "MAF": "Saint Martin (French part)",
      "MAR": "Morocco",
      "MCO": "Monaco",
      "MDA": "Moldova, Republic of",
      "MDG": "Madagascar",
      "MDV": "Maldives",
      "MEX": "Mexico",
      "MHL": "Marshall Islands",
      "MKD": "North Macedonia",
      "MLI": "Mali",
      "MLT": "Malta",
      "MMR": "Myanmar",
      "MNE": "Montenegro",
      "MNG": "Mongolia",
      "MNP": "Northern Mariana Islands",
      "MOZ": "Mozambique",
      "MRT": "Mauritania",
      "MSR": "Montserrat",
      "MTQ": "Martinique",
      "MUS": "Mauritius",
      "MWI": "Malawi",
      "MYS": "Malaysia",
      "MYT": "Mayotte",
      "NAM": "Namibia",
      "NCL": "New Caledonia",
      "NER": "Niger",
      "NFK": "Norfolk Island",
      "NGA": "Nigeria",
      "NIC": "Nicaragua",
      "NIU": "Niue",
      "NLD": "Netherlands",
      "NOR": "Norway",
      "NPL": "Nepal",
      "NRU": "Nauru",
      "NZL": "New Zealand",
      "OMN": "Oman",
      "PAK": "Pakistan",
      "PAN": "Panama",
      "PCN": "Pitcairn",
      "PER": "Peru",
      "PHL": "Philippines",
      "PLW": "Palau",
      "PNG": "Papua New Guinea",
      "POL": "Poland",
      "PRI": "Puerto Rico",
      "PRK": "Korea (Democratic People's Republic of)",
      "PRT": "Portugal",
      "PRY": "Paraguay",
      "PSE": "Palestine, State of",
      "PYF": "French Polynesia",
      "QAT": "Qatar",
      "REU": "Réunion",
      "ROU": "Romania",
      "RUS": "Russian Federation",
      "RWA": "Rwanda",
      "SAU": "Saudi Arabia",
      "SDN": "Sudan",
      "SEN": "Senegal",
      "SGP": "Singapore",
      "SGS": "South Georgia and the South Sandwich Islands",
      "SHN": "Saint Helena, Ascension and Tristan da Cunha",
      "SJM": "Svalbard and Jan Mayen",
      "SLB": "Solomon Islands",
      "SLE": "Sierra Leone",
      "SLV": "El Salvador",
      "SMR": "San Marino",
      "SOM": "Somalia",
      "SPM": "Saint Pierre and Miquelon",
      "SRB": "Serbia",
      "SSD": "South Sudan",
      "STP": "Sao Tome and Principe",
      "SUR": "Suriname",
      "SVK": "Slovakia",
      "SVN": "Slovenia",
      "SWE": "Sweden",
      "SWZ": "Eswatini",
      "SXM": "Sint Maarten (Dutch part)",
      "SYC": "Seychelles",
      "SYR": "Syrian Arab Republic",
      "TCA": "Turks and Caicos Islands",
      "TCD": "Chad",
      "TGO": "Togo",
      "THA": "Thailand",
      "TJK": "Tajikistan",
      "TKL": "Tokelau",
      "TKM": "Turkmenistan",
      "TLS": "Timor-Leste",
      "TON": "Tonga",
      "TTO": "Trinidad and Tobago",
      "TUN": "Tunisia",
      "TUR": "Turkey",
      "TUV": "Tuvalu",
      "TWN": "Taiwan, Province of China",
      "TZA": "Tanzania, United Republic of",
      "UGA": "Uganda",
      "UKR": "Ukraine",
      "UMI": "United States Minor Outlying Islands",
      "URY": "Uruguay",
      "USA": "United States of America",
      "UZB": "Uzbekistan",
      "VAT": "Holy See",
      "VCT": "Saint Vincent and the Grenadines",
      "VEN": "Venezuela (Bolivarian Republic of)",
      "VGB": "Virgin Islands (British)",
      "VIR": "Virgin Islands (U.S.)",
      "VNM": "Viet Nam",
      "VUT": "Vanuatu",
      "WLF": "Wallis and Futuna",
      "WSM": "Samoa",
      "XKX": "Kosovo",
      "YEM": "Yemen",
      "ZAF": "South Africa",
      "ZMB": "Zambia",
      "ZWE": "Zimbabwe"
    },
    "label": {
      "hidePassword": "Hide password",
      "hint": {
        "newPassword": "Your password must contain uppercase and lowercase letters, special characters, numbers and 8-30 characters.",
        "password": "Confirm your new email address with your password."
      },
      "showPassword": "Show password",
      "validation": {
        "email": "Please enter a valid email address.",
        "invalidBirthdate": "Please enter a valid date of birth.",
        "maxLength": "You have exceeded the maximum of {{max}} characters.",
        "password": "Invalid password. Your password must contain uppercase and lowercase letters, special characters, numbers and 8-30 characters.",
        "phone": "Please enter your phone number in the format +xxxxxxxxxxx.",
        "phoneBackend": "This phone number is invalid. Please check your input.",
        "phoneNoPlus": "Your phone number must start with 07 or 00.",
        "required": "This field is mandatory.",
        "zip": "Please enter a valid postal code."
      }
    },
    "links": {
      "isMyDeviceESIMCompatible": "https://support.digitalrepublic.ch/en/support/solutions/articles/33000256600-do-i-own-an-esim-compatible-device-",
      "supportHomeLink": "https://support.digitalrepublic.ch/en/support/home"
    },
    "newWelcome": {
      "initialPasswordSetup": {
        "confirmPasswordLabel": "Repeat new password",
        "errors": {
          "genericError": "Something went wrong. Please try again.",
          "unauthorized": "Your session has expired. Please sign in again using the link from your email.",
          "userNotFound": "We could not find your account. Please sign in again using the link from your email."
        },
        "headline": "Welcome to Digital Republic",
        "passwordLabel": "New password",
        "title": "Set password"
      },
      "logInForm": {
        "forgotPassword": "Forgot your password?",
        "invalidCredentialsError": "Incorrect password or email address",
        "noAccount": "Don't have an account?",
        "registerNow": "Register now",
        "submitButton": "Log in"
      },
      "magicLink": {
        "errors": {
          "consumeFailed": "Sign-in failed. Please try again or sign in with your password.",
          "expiredLink": "This link has expired. Request a new sign-in link on the sign-in screen.",
          "invalidLink": "This sign-in link is invalid",
          "notAllowed": "Sign-in with an email link is not enabled for your account. You can change this in the settings.",
          "rateLimited": "You have requested too many sign-in links. Please try again later.",
          "requestFailed": "Sign-in with an email link is currently unavailable. Please try again later or sign in with your password.",
          "usedLink": "This link has already been used"
        },
        "linkOnLogin": "Sign in with an email link",
        "request": {
          "backToPasswordLogin": "Sign in with a password",
          "description": "Enter your email address. We'll send you a secure link to sign in to the customer portal.",
          "title": "Sign in"
        },
        "sent": {
          "message": "If an account exists for this email address, you'll receive an email with a sign-in link shortly. For security reasons, the link is only valid for a limited time."
        }
      },
      "registerForm": {
        "acceptTerms": "Accept the <1>Privacy Policy</1> and <2>Terms and Conditions</2> *",
        "accountExists": "Already have an account?",
        "confirmPassword": {
          "label": "Confirm password"
        },
        "error": {
          "emailAlreadyInUse": "An account with this email address already exists",
          "invalidEmailFormat": "This email address format is not supported. Please enter a valid email address."
        },
        "logInNow": "Log in now",
        "passwordHint": "Your password must meet the following criteria:",
        "passwordRequirements": {
          "disallowedCharacter": "This character is not allowed: {{character}}",
          "disallowedCharacters": "These characters are not allowed: {{characters}}",
          "minLength": "8-30 characters",
          "numberRequired": "At least one digit (0-9)",
          "spaceCharacter": "space",
          "specialCharacter": "At least one special character (=+-^$*.[]{}()?\"!@#%&/\\,><':;|_~`)",
          "upperLowercase": "At least one lowercase and one uppercase letter (a–z, A–Z)"
        },
        "title": "Register",
        "uiFeedback": {
          "registrationSuccess": "Your account has been successfully created"
        },
        "validation": {
          "acceptTerms": "Please accept the Terms and Conditions and the Privacy Policy",
          "confirmPasswordRequired": "Please confirm your password",
          "passwordNoMatch": "Passwords do not match"
        }
      }
    },
    "sessionExpired": {
      "text": "For security reasons, you have been logged out",
      "title": "Your session has expired"
    }
  }
}
